import { REQUEST_CHECKLIST, RECEIVE_CHECKLIST, ADD_TASK, UPDATE_TASK, REMOVE_TASK, RECEIVE_TASK, SELECT_TASK, UNSELECT_TASK, RESET_CHECKLIST } from '../../actions/types/ChecklistActionTypes';

const initialState = {
  byId: {},
  groups: [],
  selectedId: null
};

const tasksReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CHECKLIST: {
      return state;
    }
    case RECEIVE_CHECKLIST: {
      const taskGroups = action.payload.checklist.checklist_task_groups;
      const byId = {};
      const groups = [];

      taskGroups.forEach((taskGroup) => {
        const tasks = taskGroup.tasks;

        groups.push({
          label: taskGroup.label,
          taskIds: tasks.map(task => task.id)
        });

        tasks.forEach(task => (byId[task.id] = task));
      });

      return Object.assign(
        {},
        state,
        { byId, groups }
      );
    }
    case RESET_CHECKLIST: {
      return initialState;
    }
    case ADD_TASK: {
      return state;
    }
    case UPDATE_TASK: {
      return state;
    }
    case REMOVE_TASK: {
      const byId = { ...state.byId };
      // delete byId[action.payload.id];

      return Object.assign({},
        state,
        { byId }
      );
    }
    case RECEIVE_TASK: {
      const byId = { ...state.byId };
      byId[action.payload.task.id] = action.payload.task;
      return Object.assign({},
        state,
        { byId }
      );
    }
    case SELECT_TASK: {
      return Object.assign({},
        state,
        { selectedId: action.payload.id }
      );
    }
    case UNSELECT_TASK: {
      return Object.assign({},
        state,
        { selectedId: null }
      );
    }
    default: return state;
  }
};

export default tasksReducer;



// WEBPACK FOOTER //
// ./src/reducers/checklist/tasks.js